import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Button } from "@/components/ui/button";
import {
  Sparkles,
  CheckCircle2,
  Facebook,
  Instagram,
  Linkedin,
  Mail,
} from "lucide-react";

export default function ThankYouPage() {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Köszönjük a megrendelést! | Kardiy</title>
        <meta name="description" content="Megrendelésed sikeresen rögzítettük. Hamarosan értesítünk a kártyapakli elkészültéről." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
    <div className="min-h-screen bg-gradient-to-b from-[#FDFBF7] to-[#FFF1F2] flex flex-col">
      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="max-w-md w-full text-center">
          {/* Success Icon */}
          <div className="mb-6">
            <div className="w-20 h-20 rounded-full bg-[#FF52A9]/10 flex items-center justify-center mx-auto">
              <CheckCircle2
                className="w-10 h-10 text-[#FF52A9]"
                strokeWidth={2.5}
              />
            </div>
          </div>

          {/* Title */}
          <h1 className="font-heading text-2xl md:text-3xl font-bold text-[#292524] mb-6">
            Sikeresen feliratkoztál!
          </h1>

          {/* What's Next Card */}
          <div className="bg-white rounded-3xl p-6 shadow-lg mb-6 text-left">
            <h2 className="font-heading text-lg font-bold text-[#292524] mb-4 text-center">
              Mi történik ezután?
            </h2>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-7 h-7 rounded-full bg-[#FF6B6B]/10 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-[#FF6B6B]">1</span>
                </div>
                <p className="text-stone-600 text-sm pt-1">
                  Email-t küldünk, amint a Kardiy elindult, hogy elsőként
                  értesülj a megjelenésről
                </p>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-7 h-7 rounded-full bg-[#FCD34D]/20 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-[#292524]">2</span>
                </div>
                <p className="text-stone-600 text-sm pt-1">
                  Amiben megkapod az egyedi{" "}
                  <span className="font-bold text-[#FF6B6B]">
                    50%-os kedvezménykódot
                  </span>
                </p>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-7 h-7 rounded-full bg-[#84A98C]/20 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-[#292524]">3</span>
                </div>
                <p className="text-stone-600 text-sm pt-1">
                  Megrendelheted egyedi beszélgetésindító kártyapaklidat, vagy
                  generálhatsz újakat a Kardiy segítségével
                </p>
              </li>
            </ul>
          </div>

          {/* Back to Home Button */}
          <Button
            onClick={() => navigate("/")}
            data-testid="back-home-btn"
            className="w-full bg-[#FF6B6B] hover:bg-[#FF5252] text-white font-bold py-5 rounded-full active:scale-95 transition-all"
          >
            Vissza a főoldalra
          </Button>

          {/* Branding */}
          <div className="flex items-center justify-center gap-2 mt-6">
            <Sparkles className="w-4 h-4 text-[#FF6B6B]" />
            <span className="font-heading text-sm font-bold text-[#292524]">
              Kardiy
            </span>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="w-full border-t border-stone-200 bg-white/50 py-6">
        <div className="flex flex-col items-center gap-4">
          {/* Social Icons */}
          <div className="flex items-center gap-4">
            <a
              href="https://www.facebook.com/profile.php?id=61582621042921"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-stone-200 flex items-center justify-center hover:bg-stone-300 transition-colors"
              data-testid="social-facebook"
            >
              <Facebook className="w-5 h-5 text-[#292524]" />
            </a>
            <a
              href="https://www.instagram.com/_kardiy/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-stone-200 flex items-center justify-center hover:bg-stone-300 transition-colors"
              data-testid="social-instagram"
            >
              <Instagram className="w-5 h-5 text-[#292524]" />
            </a>
            <a
              href="https://www.linkedin.com/company/kardiy/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-stone-200 flex items-center justify-center hover:bg-stone-300 transition-colors"
              data-testid="social-linkedin"
            >
              <Linkedin className="w-5 h-5 text-[#292524]" />
            </a>
            <a
              href="mailto:hello@kardiy.com"
              className="w-10 h-10 rounded-full bg-stone-200 flex items-center justify-center hover:bg-stone-300 transition-colors"
              data-testid="social-email"
            >
              <Mail className="w-5 h-5 text-[#292524]" />
            </a>
          </div>

          {/* Copyright */}
          <p className="text-stone-500 text-sm">
            © 2026 Kardiy. Minden jog fenntartva.
          </p>
        </div>
      </footer>
    </div>
    </>
  );
}
